import { Immutable } from "immer";
import React from "react";

import { IImageURL, isoImageURL } from "../../../models/nominals";
import { HeroPicture } from "../HeroPicture";

export const PDPHero = (
    props: Immutable<{
        defaultBackgroundImage: IImageURL | null;
        defaultMobileBackgroundImage: IImageURL | null;
        defaultImageTitle: string;
    }>,
): React.JSX.Element => {
    return (
        <HeroPicture
            imageUrl={
                props.defaultBackgroundImage
                    ? isoImageURL.unwrap(props.defaultBackgroundImage)
                    : null
            }
            mobileImageUrl={
                props.defaultMobileBackgroundImage
                    ? isoImageURL.unwrap(props.defaultMobileBackgroundImage)
                    : null
            }
            imageAlt={props.defaultImageTitle}
        />
    );
};
